import { createRouter } from '@tanstack/react-router'

import { trpcLoader } from './client.ts'
import { RootErrorBoundary } from './components/templates/error-boundary.tsx'
import { sessionManager } from './lib/session.ts'
import { routeTree } from './routeTree.gen.ts'
import { queryClient } from './shared/query-client.ts'

import { NotFoundPage } from '#/shared/components/not-found-page/not-found-page.tsx'

export const router = createRouter({
  routeTree,
  scrollToTopSelectors: ['[data-slot="layout-body"]'],
  context: {
    queryClient,
    trpc: trpcLoader,
    session: sessionManager,
  },
  defaultPreload: 'intent',
  defaultNotFoundComponent: () => <NotFoundPage />,
  defaultErrorComponent: RootErrorBoundary,
  // Disabled to prevent flickering on modal open
  // Deeper fix planned (OMN-1089)
  // defaultViewTransition: true,
})

declare module '@tanstack/react-router' {
  // oxlint-disable-next-line typescript/consistent-type-definitions -- interface required for declaration merging into @tanstack/react-router
  interface Register {
    router: typeof router
  }

  // oxlint-disable-next-line typescript/consistent-type-definitions -- interface required for declaration merging into @tanstack/react-router
  interface HistoryState {
    /** A standalone form's step, kept out of the tracked URL. The flow parses it: an entry can hold an older shape. */
    standaloneFormEntry?: unknown
  }
}
